import * as Sentry from '@sentry/remix'
import { useEffect } from 'react'
import { useLocation, useMatches } from 'react-router'

import { variables } from './variables.client'

const shouldSentryBeUsed = () => {
  if (!variables.SENTRY_DSN) {
    console.info('Sentry reporting disabled; set SENTRY_DSN to enable')
    return false
  }
  return true
}

export const initSentry = () => {
  if (!shouldSentryBeUsed()) {
    return false
  }
  console.info('Sentry reporting enabled')

  Sentry.init({
    dsn: variables.SENTRY_DSN,
    environment: variables.SENTRY_ENVIRONMENT,
    release: variables.SENTRY_RELEASE,

    // debug: variables.NODE_ENV === 'development',

    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      // This is a known issue: https://github.com/getsentry/sentry-javascript/issues/9728

      Sentry.replayIntegration(),
    ],
  })
}
